/* TriRig homepage wide-screen scaling helper (Grok, Nov 2026). Pairs with home-wide.css.
   CSS zoom enlarges the homepage on 1500px+ windows, but browsers pick srcset images from the unzoomed size,
   so they would load images that are too small and look soft. This sets each image's "sizes" to its real
   on-screen width. It does nothing below 1500px. */
(function(){
  var mq=window.matchMedia('(min-width: 1500px)');
  function main(){return document.getElementById('MainContent')}
  function z(){var m=main();if(!m)return 1;var v=parseFloat(getComputedStyle(m).zoom);return v>0?v:1}
  document.addEventListener('lazybeforesizes',function(e){if(mq.matches&&e.detail&&e.detail.width&&main()&&main().contains(e.target))e.detail.width=Math.ceil(e.detail.width*z())});
  function fix(){
    if(!mq.matches)return;var m=main();if(!m)return;var k=z();if(k<=1)return;
    var imgs=m.querySelectorAll('img[srcset],img[data-srcset]');
    for(var i=0;i<imgs.length;i++){var im=imgs[i];var r=im.getBoundingClientRect().width;var w=Math.ceil(Math.max(r,im.offsetWidth*k));
      if(w<40)continue;var cur=parseInt(im.getAttribute('data-hw-sizes')||'0',10);if(w<=cur)continue;
      im.setAttribute('data-hw-sizes',w);if(im.hasAttribute('srcset'))im.sizes=w+'px';}
  }
  var t;function later(){clearTimeout(t);t=setTimeout(fix,150)}
  if(document.readyState!=='loading')fix();else document.addEventListener('DOMContentLoaded',fix);
  window.addEventListener('load',fix);window.addEventListener('resize',later);
  document.addEventListener('lazyloaded',later);
  if(mq.addEventListener)mq.addEventListener('change',later);
  var n=0,iv=setInterval(function(){fix();if(++n>10)clearInterval(iv)},1000);
})();
